import Vue from 'vue'
import VueRouter from 'vue-router'
const { hasActiveIdentity } = require('@/utils/auth')

Vue.use(VueRouter)

const HomePage = () => import('@/views/HomePage.vue')
const MainLayout = () => import('@/components/MainLayout.vue')
const SmartChatPage = () => import('@/views/SmartChatPage.vue')
const KnowledgeGraphPage = () => import('@/views/KnowledgeGraphPage.vue')
const KnowledgeTextPage = () => import('@/views/KnowledgeTextPage.vue')
const AgentManagementPage = () => import('@/views/AgentManagementPage.vue')
const WorkflowPage = () => import('@/views/WorkflowPage.vue')
const EvaluationPage = () => import('@/views/EvaluationPage.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      title: '智图安全 - 首页'
    }
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: 'chat',
        name: 'SmartChat',
        component: SmartChatPage,
        meta: {
          title: '智能问答',
          requiresAuth: true
        }
      },
      {
        path: 'knowledge/graph',
        name: 'KnowledgeGraph',
        component: KnowledgeGraphPage,
        meta: {
          title: '知识图谱管理',
          requiresAuth: true
        }
      },
      {
        path: 'knowledge/text',
        name: 'KnowledgeText',
        component: KnowledgeTextPage,
        meta: {
          title: '文本知识管理',
          requiresAuth: true
        }
      },
      {
        path: 'agents',
        name: 'AgentManagement',
        component: AgentManagementPage,
        meta: {
          title: '智能体管理',
          requiresAuth: true
        }
      },
      {
        path: 'workflow',
        name: 'Workflow',
        component: WorkflowPage,
        meta: {
          title: '系统工作流',
          requiresAuth: true
        }
      },
      {
        path: 'evaluation',
        name: 'Evaluation',
        component: EvaluationPage,
        meta: {
          title: '评估与测试',
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.meta.requiresAuth && !hasActiveIdentity()) {
    next('/')
    return
  }

  next()
})

export default router
